module.exports = __webpack_public_path__ + "static/acctreedesc-0793a6e52cdef7caaebce2358a9ded3a.png";